// import React from "react";

// const workflowSteps = [
//   {
//     title: "Employee Login",
//     description:
//       "Employees securely access the HRMS portal using role-based authentication.",
//   },

//   {
//     title: "Attendance & Requests",
//     description:
//       "Attendance, leave requests, reimbursements, and work updates are submitted.",
//   },

//   {
//     title: "Manager Approval",
//     description:
//       "Managers review requests, track team activity, and approve workflows instantly.",
//   },

//   {
//     title: "HR Processing",
//     description:
//       "HR teams process payroll, attendance records, compliance, and employee operations.",
//   },

//   {
//     title: "Analytics & Reports",
//     description:
//       "Generate workforce analytics, performance insights, and enterprise reports.",
//   },
// ];

// const WorkflowSection = () => {
//   return (
//     <section className="workflow-section-wrapper">

//       <div className="website-section-header">

//         <p className="website-section-mini-title">
//           WORKFLOW AUTOMATION
//         </p>

//         <h2 className="website-section-title">
//           Streamlined HR Operations <br />
//           from Start to Finish
//         </h2>

//         <p className="website-section-description">
//           Simplify workforce management with intelligent automation,
//           real-time approvals, and centralized employee workflows.
//         </p>

//       </div>

//       <div className="workflow-timeline-wrapper">

//         {workflowSteps.map((step, index) => (
//           <div className="workflow-step-card" key={index}>

//             <div className="workflow-step-number">
//               0{index + 1}
//             </div>

//             <div className="workflow-step-content">

//               <h3>{step.title}</h3>

//               <p>{step.description}</p>

//             </div>

//           </div>
//         ))}

//       </div>

//     </section>
//   );
// };

// export default WorkflowSection;










// import React from "react";

// import { motion } from "framer-motion";
// import "../styles/workflowsection.css";

// const workflowSteps = [
//   {
//     title: "Employee Login",

//     description:
//       "Employees securely access the HRMS portal using role-based authentication.",
//   },

//   {
//     title: "Attendance & Requests",

//     description:
//       "Attendance, leave requests, reimbursements, and work updates are submitted.",
//   },

//   {
//     title: "Manager Approval",

//     description:
//       "Managers review requests, track team activity, and approve workflows instantly.",
//   },

//   {
//     title: "HR Processing",

//     description:
//       "HR teams process payroll, attendance records, compliance, and employee operations.",
//   },

//   {
//     title: "Analytics & Reports",

//     description:
//       "Generate workforce analytics, performance insights, and enterprise reports.",
//   },
// ];

// const WorkflowSection = () => {

//   return (

//     <section className="workflow-section-wrapper">

//       {/* HEADER */}

//       <motion.div
//         className="website-section-header"
//         initial={{
//           opacity: 0,
//           y: 50,
//         }}
//         whileInView={{
//           opacity: 1,
//           y: 0,
//         }}
//         viewport={{
//           once: true,
//         }}
//         transition={{
//           duration: 0.9,
//         }}
//       >

//         <motion.p
//           className="website-section-mini-title"
//           initial={{
//             opacity: 0,
//             y: 20,
//           }}
//           whileInView={{
//             opacity: 1,
//             y: 0,
//           }}
//           viewport={{
//             once: true,
//           }}
//           transition={{
//             delay: 0.1,
//           }}
//         >

//           WORKFLOW AUTOMATION

//         </motion.p>

//         <motion.h2
//           className="website-section-title"
//           initial={{
//             opacity: 0,
//             y: 20,
//           }}
//           whileInView={{
//             opacity: 1,
//             y: 0,
//           }}
//           viewport={{
//             once: true,
//           }}
//           transition={{
//             delay: 0.2,
//           }}
//         >

//           Streamlined HR Operations <br />

//           from Start to Finish

//         </motion.h2>

//         <motion.p
//           className="website-section-description"
//           initial={{
//             opacity: 0,
//             y: 20,
//           }}
//           whileInView={{
//             opacity: 1,
//             y: 0,
//           }}
//           viewport={{
//             once: true,
//           }}
//           transition={{
//             delay: 0.3,
//           }}
//         >

//           Simplify workforce management with intelligent automation,
//           real-time approvals, and centralized employee workflows.

//         </motion.p>

//       </motion.div>

//       {/* TIMELINE */}

//       <div className="workflow-timeline-wrapper">

//         {workflowSteps.map((step, index) => (

//           <motion.div
//             className="workflow-step-card"
//             key={index}
//             initial={{
//               opacity: 0,
//               x: index % 2 === 0 ? -80 : 80,
//               scale: 0.92,
//             }}
//             whileInView={{
//               opacity: 1,
//               x: 0,
//               scale: 1,
//             }}
//             viewport={{
//               once: true,
//               amount: 0.3,
//             }}
//             transition={{
//               duration: 0.8,
//               delay: index * 0.15,
//               ease: "easeOut",
//             }}
//             whileHover={{
//               y: -10,
//               scale: 1.02,
//             }}
//           >

//             {/* STEP NUMBER */}

//             <motion.div
//               className="workflow-step-number"
//               animate={{
//                 boxShadow: [
//                   "0 0 0px rgba(37,99,235,0.0)",
//                   "0 0 25px rgba(37,99,235,0.4)",
//                   "0 0 0px rgba(37,99,235,0.0)",
//                 ],
//               }}
//               transition={{
//                 repeat: Infinity,
//                 duration: 3,
//                 delay: index * 0.4,
//               }}
//             >

//               0{index + 1}

//             </motion.div>

//             {/* CONTENT */}

//             <div className="workflow-step-content">

//               <motion.h3
//                 initial={{
//                   opacity: 0,
//                   y: 10,
//                 }}
//                 whileInView={{
//                   opacity: 1,
//                   y: 0,
//                 }}
//                 viewport={{
//                   once: true,
//                 }}
//                 transition={{
//                   delay: 0.2 + index * 0.1,
//                 }}
//               >

//                 {step.title}

//               </motion.h3>

//               <motion.p
//                 initial={{
//                   opacity: 0,
//                   y: 10,
//                 }}
//                 whileInView={{
//                   opacity: 1,
//                   y: 0,
//                 }}
//                 viewport={{
//                   once: true,
//                 }}
//                 transition={{
//                   delay: 0.3 + index * 0.1,
//                 }}
//               >

//                 {step.description}

//               </motion.p>

//             </div>

//           </motion.div>

//         ))}

//       </div>

//     </section>

//   );
// };

// export default WorkflowSection;

















// import React, { useRef } from "react";
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import "../styles/workflowsection.css";

// const workflowSteps = [
//   { title: "Employee Login", description: "Employees securely access the HRMS portal using role-based authentication." },
//   { title: "Attendance & Requests", description: "Attendance, leave requests, reimbursements, and work updates are submitted." },
//   { title: "Manager Approval", description: "Managers review requests, track team activity, and approve workflows instantly." },
//   { title: "HR Processing", description: "HR teams process payroll, attendance records, compliance, and employee operations." },
//   { title: "Analytics & Reports", description: "Generate workforce analytics, performance insights, and enterprise reports." },
// ];

// const WorkflowSection = () => {
//   const containerRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: containerRef,
//     offset: ["start end", "end start"], // Starts as it enters view, ends as it leaves
//   });

//   // Spring physics for the center line: stiff but smooth
//   const smoothLineProgress = useSpring(scrollYProgress, {
//     stiffness: 70,
//     damping: 30,
//     restDelta: 0.001
//   });

//   return (
//     <section className="workflow-section-wrapper" ref={containerRef}>
//       <div className="website-section-header">
//         <p className="website-section-mini-title">WORKFLOW AUTOMATION</p>
//         <h2 className="website-section-title">Streamlined HR Operations</h2>
//       </div>

//       <div className="workflow-timeline-container">
//         {/* THE SMOOTH ZIPPER LINE */}
//         <div className="zipper-track">
//           <motion.div
//             className="zipper-progress"
//             style={{ 
//               scaleY: smoothLineProgress, 
//               originY: 0,
//               // Adding a glow effect that moves with the tip
//               boxShadow: "0px 0px 20px rgba(23, 211, 39, 0.6)" 
//             }}
//           />
//         </div>

//         {workflowSteps.map((step, index) => (
//           <StepCard key={index} step={step} index={index} />
//         ))}
//       </div>
//     </section>
//   );
// };

// const StepCard = ({ step, index }) => {
//   const cardRef = useRef(null);

//   // Track specific card position relative to the viewport
//   const { scrollYProgress } = useScroll({
//     target: cardRef,
//     offset: ["start 0.85", "center 0.5"],
//   });

//   // Physics-based spring for the card movement
//   const smoothProgress = useSpring(scrollYProgress, {
//     stiffness: 50,
//     damping: 20
//   });

//   // Calculate "Unzipping" movement
//   // index % 2 === 0 ? -100 : 100 means start from 100px away and meet at 0
//   const xOffset = index % 2 === 0 ? -100 : 100;

//   const x = useTransform(smoothProgress, [0, 1], [xOffset, 0]);
//   const opacity = useTransform(smoothProgress, [0, 0.6], [0, 1]);
//   const scale = useTransform(smoothProgress, [0, 1], [0.8, 1]);
//   const rotate = useTransform(smoothProgress, [0, 1], [index % 2 === 0 ? -5 : 5, 0]);

//   return (
//     <div className={`workflow-step-row ${index % 2 === 0 ? "left" : "right"}`} ref={cardRef}>
//       <motion.div
//         className="workflow-step-card"
//         style={{ 
//           x, 
//           opacity, 
//           scale,
//           rotate,
//           willChange: "transform, opacity" // Optimization hint for browsers
//         }}
//       >
//         <div className="workflow-step-number">0{index + 1}</div>
//         <div className="workflow-step-content">
//           <h3>{step.title}</h3>
//           <p>{step.description}</p>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default WorkflowSection;
















// import React, { useRef } from "react";
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import "../styles/workflowsection.css";

// const workflowSteps = [
//   {
//     title: "Employee Login",
//     description:
//       "Employees securely access the HRMS portal using role-based authentication.",
//   },
//   {
//     title: "Attendance & Requests",
//     description:
//       "Attendance, leave requests, reimbursements, and work updates are submitted.",
//   },
//   {
//     title: "Manager Approval",
//     description:
//       "Managers review requests, track team activity, and approve workflows instantly.",
//   },
//   {
//     title: "HR Processing",
//     description:
//       "HR teams process payroll, attendance records, compliance, and employee operations.",
//   },
//   {
//     title: "Analytics & Reports",
//     description:
//       "Generate workforce analytics, performance insights, and enterprise reports.",
//   },
// ];

// const WorkflowSection = () => {
//   const containerRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: containerRef,
//     offset: ["start 90%", "end 20%"], // faster overall line animation
//   });

//   const smoothLineProgress = useSpring(scrollYProgress, {
//     stiffness: 140, // faster
//     damping: 22,
//     restDelta: 0.001,
//   });

//   return (
//     <section className="workflow-section-wrapper" ref={containerRef}>
//       <div className="website-section-header">
//         <p className="website-section-mini-title">WORKFLOW AUTOMATION</p>
//         <h2 className="website-section-title">Streamlined HR Operations</h2>
//       </div>

//       <div className="workflow-timeline-container">
//         <div className="zipper-track">
//           <motion.div
//             className="zipper-progress"
//             style={{
//               scaleY: smoothLineProgress,
//               originY: 0,
//               boxShadow: "0px 0px 18px rgba(23, 211, 39, 0.6)",
//             }}
//           />
//         </div>

//         {workflowSteps.map((step, index) => (
//           <StepCard key={index} step={step} index={index} />
//         ))}
//       </div>
//     </section>
//   );
// };

// const StepCard = ({ step, index }) => {
//   const cardRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: cardRef,
//     offset: ["start 95%", "center 75%"], // opens much earlier
//   });

//   const smoothProgress = useSpring(scrollYProgress, {
//     stiffness: 180, // snappier animation
//     damping: 18,
//   });

//   const xOffset = index % 2 === 0 ? -70 : 70; // reduced travel distance

//   const x = useTransform(smoothProgress, [0, 1], [xOffset, 0]);
//   const opacity = useTransform(smoothProgress, [0, 0.4], [0, 1]);
//   const scale = useTransform(smoothProgress, [0, 1], [0.9, 1]);
//   const rotate = useTransform(
//     smoothProgress,
//     [0, 1],
//     [index % 2 === 0 ? -2 : 2, 0]
//   );

//   return (
//     <div
//       className={`workflow-step-row ${index % 2 === 0 ? "left" : "right"}`}
//       ref={cardRef}
//     >
//       <motion.div
//         className="workflow-step-card"
//         style={{
//           x,
//           opacity,
//           scale,
//           rotate,
//           willChange: "transform, opacity",
//         }}
//       >
//         <div className="workflow-step-number">0{index + 1}</div>
//         <div className="workflow-step-content">
//           <h3>{step.title}</h3>
//           <p>{step.description}</p>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default WorkflowSection;















// import React, { useRef } from "react";
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { Plane } from "lucide-react"; // Optional: using an icon library
// import "../styles/workflowsection.css";

// const workflowSteps = [
//   { title: "Employee Login", description: "Employees securely access the HRMS portal." },
//   { title: "Attendance & Requests", description: "Attendance and leave requests are submitted." },
//   { title: "Manager Approval", description: "Managers review and approve workflows instantly." },
//   { title: "HR Processing", description: "HR teams process payroll and compliance." },
//   { title: "Analytics & Reports", description: "Generate workforce analytics and reports." },
// ];

// const WorkflowSection = () => {
//   const containerRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: containerRef,
//     offset: ["start 40%", "end 20%"],
//   });

//   const smoothLineProgress = useSpring(scrollYProgress, {
//     stiffness: 140,
//     damping: 22,
//     restDelta: 0.001,
//   });

//   // Map the scroll progress (0 to 1) to the vertical position (0% to 100%)
//   const planeTop = useTransform(smoothLineProgress, [0, 1], ["0%", "100%"]);

//   return (
//     <section className="workflow-section-wrapper" ref={containerRef}>
//       <div className="website-section-header">
//         <p className="website-section-mini-title">WORKFLOW AUTOMATION</p>
//         <h2 className="website-section-title">Streamlined HR Operations</h2>
//       </div>

//       <div className="workflow-timeline-container">
//         <div className="zipper-track">
//           {/* The Moving Line */}
//           <motion.div
//             className="zipper-progress"
//             style={{
//               scaleY: smoothLineProgress,
//               originY: 0,
//               boxShadow: "0px 0px 18px rgba(23, 211, 39, 0.6)",
//             }}
//           />

//           {/* The Airplane */}
//           <motion.div
//             style={{
//               position: "absolute",
//               top: planeTop,
//               left: "50%",
//               x: "-50%", // Center horizontally on the line
//               y: "-50%", // Center vertically on the line tip
//               zIndex: 10,
//               rotate: 137, // Point the plane downwards
//             }}
//           >
//             {/* You can replace this icon with an <img> tag or SVG */}
//             <Plane size={60} color="white" fill="#white" />
//           </motion.div>
//         </div>

//         {workflowSteps.map((step, index) => (
//           <StepCard key={index} step={step} index={index} />
//         ))}
//       </div>
//     </section>
//   );
// };

// const StepCard = ({ step, index }) => {
//   const cardRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: cardRef,
//     offset: ["start 95%", "center 75%"],
//   });

//   const smoothProgress = useSpring(scrollYProgress, {
//     stiffness: 180,
//     damping: 18,
//   });

//   const xOffset = index % 2 === 0 ? -70 : 70;
//   const x = useTransform(smoothProgress, [0, 1], [xOffset, 0]);
//   const opacity = useTransform(smoothProgress, [0, 0.4], [0, 1]);
//   const scale = useTransform(smoothProgress, [0, 1], [0.9, 1]);
//   const rotate = useTransform(smoothProgress, [0, 1], [index % 2 === 0 ? -2 : 2, 0]);

//   return (
//     <div className={`workflow-step-row ${index % 2 === 0 ? "left" : "right"}`} ref={cardRef}>
//       <motion.div
//         className="workflow-step-card"
//         style={{ x, opacity, scale, rotate,  willChange: "transform, opacity" }}
//       >
//         <div className="workflow-step-number">0{index + 1}</div>
//         <div className="workflow-step-content">
//           <h3>{step.title}</h3>
//           <p>{step.description}</p>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default WorkflowSection;


















// import React, { useRef } from "react";
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { Plane } from "lucide-react"; // Optional: using an icon library
// import "../styles/workflowsection.css";

// const workflowSteps = [
//   { title: "Employee Login", description: "Employees securely access the HRMS portal." },
//   { title: "Attendance & Requests", description: "Attendance and leave requests are submitted." },
//   { title: "Manager Approval", description: "Managers review and approve workflows instantly." },
//   { title: "HR Processing", description: "HR teams process payroll and compliance." },
//   { title: "Analytics & Reports", description: "Generate workforce analytics and reports." },
// ];

// const WorkflowSection = () => {
//   const containerRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: containerRef,
//     offset: ["start 40%", "end 20%"],
//   });

//   const smoothLineProgress = useSpring(scrollYProgress, {
//     stiffness: 140,
//     damping: 22,
//     restDelta: 0.001,
//   });

//   // Map the scroll progress (0 to 1) to the vertical position (0% to 100%)
//   const planeTop = useTransform(smoothLineProgress, [0, 1], ["0%", "100%"]);

//   return (
//     <section className="workflow-section-wrapper" ref={containerRef}>
//       <div className="website-section-header">
//         <p className="website-section-mini-title">WORKFLOW AUTOMATION</p>
//         <h2 className="website-section-title">Streamlined HR Operations</h2>
//       </div>

//       <div className="workflow-timeline-container">
//         <div className="zipper-track">
//           {/* The Moving Line */}
//           <motion.div
//             className="zipper-progress"
//             style={{
//               scaleY: smoothLineProgress,
//               originY: 0,
//               boxShadow: "0px 0px 18px rgba(23, 211, 39, 0.6)",
//             }}
//           />

//           {/* The Airplane */}
//           <motion.div
//             style={{
//               position: "absolute",
//               top: planeTop,
//               left: "50%",
//               x: "-50%", // Center horizontally on the line
//               y: "-50%", // Center vertically on the line tip
//               zIndex: 999999,
//               rotate: 137, // Point the plane downwards
//             }}
//           >
//             {/* You can replace this icon with an <img> tag or SVG */}
//             <Plane size={60} color="white" fill="#white" />
//           </motion.div>
//         </div>

//         {workflowSteps.map((step, index) => (
//           <StepCard key={index} step={step} index={index} />
//         ))}
//       </div>
//     </section>
//   );
// };

// const StepCard = ({ step, index }) => {
//   const cardRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: cardRef,
//     offset: ["start 95%", "center 75%"],
//   });

//   const smoothProgress = useSpring(scrollYProgress, {
//     stiffness: 180,
//     damping: 18,
//   });

//   const xOffset = index % 2 === 0 ? -70 : 70;
//   const x = useTransform(smoothProgress, [0, 1], [xOffset, 0]);
//   const opacity = useTransform(smoothProgress, [0, 0.4], [0, 1]);
//   const scale = useTransform(smoothProgress, [0, 1], [0.9, 1]);
//   const rotate = useTransform(smoothProgress, [0, 1], [index % 2 === 0 ? -2 : 2, 0]);

//   return (
//     <div className={`workflow-step-row ${index % 2 === 0 ? "left" : "right"}`} ref={cardRef}>
//       <motion.div
//         className="workflow-step-card"
//         style={{ x, opacity, scale, rotate,  willChange: "transform, opacity" }}
//       >
//         <div className="workflow-step-number">0{index + 1}</div>
//         <div className="workflow-step-content">
//           <h3>{step.title}</h3>
//           <p>{step.description}</p>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default WorkflowSection;

















// import React, { useRef } from "react";
// import { motion, useScroll, useTransform, useSpring } from "framer-motion";
// import { Plane } from "lucide-react";
// import "../styles/workflowsection.css";



// const workflowSteps = [
//   {
//     title: "Employee Onboarding",
//     description:
//       "Create employee profiles, assign departments, roles, and organizational details.",
//   },
//   {
//     title: "Attendance Tracking",
//     description:
//       "Monitor attendance, punch-ins, work hours, and workforce availability in real time.",
//   },
//   {
//     title: "Leave Management",
//     description:
//       "Employees submit leave requests while managers review and approve requests digitally.",
//   },
//   {
//     title: "Pay & Benefits",
//     description:
//       "Access salary slips, Form 16, appraisal letters, and employee documents securely.",
//   },
//   {
//     title: "Performance & OKRs",
//     description:
//       "Track employee goals, OKRs, reviews, feedback, and performance progress efficiently.",
//   },
//   {
//     title: "One-on-One Meetings",
//     description:
//       "Schedule discussions, assign action items, record notes, and track follow-up activities.",
//   },
//   {
//     title: "IT & Equipment Support",
//     description:
//       "Raise support requests, request equipment, and monitor issue resolution workflows.",
//   },
//   {
//     title: "Reimbursements",
//     description:
//       "Submit expense claims and manage reimbursement approvals through automated workflows.",
//   },
//   {
//     title: "Employee Engagement",
//     description:
//       "Share announcements, recognition programs, celebrations, and quarterly updates.",
//   },
//   {
//     title: "Career Growth & Development",
//     description:
//       "Support employee development through career pathways and continuous growth opportunities.",
//   },
// ];

// const WorkflowSection = () => {
//   const containerRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: containerRef,
//     offset: ["start 40%", "end 20%"],
//   });

//   const smoothLineProgress = useSpring(scrollYProgress, {
//     stiffness: 140,
//     damping: 22,
//     restDelta: 0.001,
//   });

//   return (
//     <section
//       className="workflow-section-wrapper"
//       ref={containerRef}
//     >
//       <div className="website-section-header">
//         <p className="website-section-mini-title">
//           WORKFLOW AUTOMATION
//         </p>
//         <h2 className="website-section-title">
//           Streamlined HR Operations
//         </h2>
//       </div>

//       <div className="workflow-timeline-container">
//         {/* Timeline Line */}
//         <div className="zipper-track">
//           <motion.div
//             className="zipper-progress"
//             style={{
//               scaleY: smoothLineProgress,
//               transformOrigin: "top",
//               boxShadow:
//                 "0px 0px 18px rgba(23, 211, 39, 0.6)",
//             }}
//           />

//           {/* Airplane */}
//           <motion.div
//             className="plane-wrapper"
//             style={{
//               top: useTransform(
//                 smoothLineProgress,
//                 [0, 1],
//                 ["0%", "100%"]
//               ),
//             }}
//           >
//             <Plane
//               size={60}
//               color="white"
//               strokeWidth={2.5}
//             />
//           </motion.div>
//         </div>

//         {workflowSteps.map((step, index) => (
//           <StepCard
//             key={index}
//             step={step}
//             index={index}
//           />
//         ))}
//       </div>
//     </section>
//   );
// };

// const StepCard = ({ step, index }) => {
//   const cardRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: cardRef,
//     offset: ["start 95%", "center 75%"],
//   });

//   const smoothProgress = useSpring(scrollYProgress, {
//     stiffness: 180,
//     damping: 18,
//   });

//   const xOffset = index % 2 === 0 ? -70 : 70;

//   const x = useTransform(
//     smoothProgress,
//     [0, 1],
//     [xOffset, 0]
//   );

//   const opacity = useTransform(
//     smoothProgress,
//     [0, 0.4],
//     [0, 1]
//   );

//   const scale = useTransform(
//     smoothProgress,
//     [0, 1],
//     [0.9, 1]
//   );

//   const rotate = useTransform(
//     smoothProgress,
//     [0, 1],
//     [index % 2 === 0 ? -2 : 2, 0]
//   );

//   return (
//     <div
//       className={`workflow-step-row ${
//         index % 2 === 0 ? "left" : "right"
//       }`}
//       ref={cardRef}
//     >
//       <motion.div
//         className="workflow-step-card"
//         style={{
//           x,
//           opacity,
//           scale,
//           rotate,
//           willChange: "transform, opacity",
//         }}
//       >
//         <div className="workflow-step-number">
//           0{index + 1}
//         </div>

//         <div className="workflow-step-content">
//           <h3>{step.title}</h3>
//           <p>{step.description}</p>
//         </div>
//       </motion.div>
//     </div>
//   );
// };

// export default WorkflowSection;



















import React, { useRef } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import { Plane } from "lucide-react";
import "../styles/workflowsection.css";



const workflowSteps = [
  {
    title: "Centralize Your Business",
    description:
      "Bring HR, recruitment, payroll, CRM, inventory, procurement, and warehouse operations into one connected platform.",
  },
  {
    title: "Recruit Top Talent",
    description:
      "Manage job postings, candidate pipelines, interviews, and hiring workflows using Hiring Hub.",
  },
  {
    title: "Manage Your Workforce",
    description:
      "Handle employee records, attendance, leave management, and performance with GTELINQ HRMS.",
  },
  {
    title: "Automate Payroll",
    description:
      "Generate salaries, payslips, statutory reports, and employee benefits with automated payroll processing.",
  },
  {
    title: "Grow Customer Relationships",
    description:
      "Track leads, manage sales opportunities, customer interactions, and follow-ups using CRM.",
  },
  {
    title: "Control Inventory",
    description:
      "Monitor stock availability, product movement, inventory levels, and warehouse visibility in real time.",
  },
  {
    title: "Simplify Procurement",
    description:
      "Create purchase requests, manage vendors, approve purchase orders, and streamline procurement cycles.",
  },
  {
    title: "Optimize Warehouses",
    description:
      "Manage storage, goods movement, dispatch operations, and warehouse efficiency from one dashboard.",
  },
  {
    title: "Connected Business Insights",
    description:
      "Analyze enterprise-wide data with unified dashboards, reports, and real-time business intelligence.",
  },
  {
    title: "Scale with Confidence",
    description:
      "As your business grows, Genesis Tech solutions grow with you through secure, scalable enterprise software.",
  },
];

const WorkflowSection = () => {
  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start 40%", "end 10%"],
  });

  const smoothLineProgress = useSpring(scrollYProgress, {
    stiffness: 140,
    damping: 22,
    restDelta: 0.001,
  });

  return (
    <section
      className="workflow-section-wrapper"
      ref={containerRef}
    >
      <div className="website-section-header">
        <p className="website-section-mini-title">
          BUSINESS TRANSFORMATION
        </p>

        <h2 className="website-section-title">
          From Operations
          <br />
          <span>To Business Growth</span>
        </h2>
      </div>

      <div className="workflow-timeline-container">
        {/* Timeline Line */}
        <div className="zipper-track">
          <motion.div
            className="zipper-progress"
            style={{
              scaleY: smoothLineProgress,
              transformOrigin: "top",
              boxShadow:
                "0px 0px 18px rgba(23, 211, 39, 0.6)",
            }}
          />

          {/* Airplane */}
          <motion.div
            className="plane-wrapper"
            style={{
              top: useTransform(
                smoothLineProgress,
                [0, 1],
                ["0%", "100%"]
              ),
            }}
          >
            <Plane
              size={60}
              color="white"
              strokeWidth={2.5}
            />
          </motion.div>
        </div>

        {workflowSteps.map((step, index) => (
          <StepCard
            key={index}
            step={step}
            index={index}
          />
        ))}
      </div>
    </section>
  );
};

const StepCard = ({ step, index }) => {
  const cardRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: cardRef,
    offset: ["start 95%", "center 75%"],
  });

  const smoothProgress = useSpring(scrollYProgress, {
    stiffness: 180,
    damping: 18,
  });

  const xOffset = index % 2 === 0 ? -70 : 70;

  const x = useTransform(
    smoothProgress,
    [0, 1],
    [xOffset, 0]
  );

  const opacity = useTransform(
    smoothProgress,
    [0, 0.4],
    [0, 1]
  );

  const scale = useTransform(
    smoothProgress,
    [0, 1],
    [0.9, 1]
  );

  const rotate = useTransform(
    smoothProgress,
    [0, 1],
    [index % 2 === 0 ? -2 : 2, 0]
  );

  return (
    <div
      className={`workflow-step-row ${index % 2 === 0 ? "left" : "right"
        }`}
      ref={cardRef}
    >
      <motion.div
        className="workflow-step-card"
        style={{
          x,
          opacity,
          scale,
          rotate,
          willChange: "transform, opacity",
        }}
      >
        <div className="workflow-step-number">
          0{index + 1}
        </div>

        <div className="workflow-step-content">
          <h3>{step.title}</h3>
          <p>{step.description}</p>
        </div>
      </motion.div>
    </div>
  );
};

export default WorkflowSection;